import React, { useEffect, useState } from 'react'
import { Alert } from 'antd'
import { RouteComponentProps } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import { Drawer, PageHeader, Button } from 'src/components/Ant'
import { getBedrooms } from 'src/core/store/ducks/partners/bedrooms/actions'
import { getBedroomsOffer } from 'src/core/store/ducks/partners/offer/actions'
import { Id } from 'src/types'
import { useT } from 'src/core/hooks/use-translation'
import useDocumentTitle from 'src/hooks/use-document-title'

import * as CSS from './styles'

import { SideModalOffer } from './components/sideModalOffer'
import Table from './components/table'

interface Params {
  partner_id: string
  hotel_id: string
  agency_partner_id: string
}

export interface DataSourceBedroomsOffer {
  id: Id
  start_date: string
  end_date: string
  tax_value: number
  description: string
  fare_value: number
  active: boolean
  agency_partner: {
    agency_partner_id: Id
    partner_id: Id
    description: String
    active: Boolean
  }
  agency_partner_hotel_agreement: {
    agency_partner_hotel_agreement_id: Id
    agency_partner_hotel_offer_id: Id
    agreement: {
      agreement_id: Id
      organization_id: Id
      service_hub_id: Id
      agreement_type: String
      integration_type: String
      name: String
      code: String
    }
  }
}

export default function BedRooms({
  history,
  match: {
    params: { partner_id, hotel_id, agency_partner_id }
  }
}: RouteComponentProps<Params>) {
  useDocumentTitle('web.table.bedrooms.bedrooms')

  const dispatch = useDispatch()

  const {
    agency_partner_hotel_agreements,
    agency_partner_hotel_offers,
    partner_hotel_rooms
  } = useSelector((state: ApplicationState) => ({
    agency_partner_hotel_agreements: state.agency_partner_hotel_agreements,
    agency_partner_hotel_offers: state.agency_partner_hotel_offers,
    partner_hotel_rooms: state.partner_hotel_rooms
  }))

  const [currentPage, setCurrentPage] = useState<number>(1)
  const [roomId, setRoomId] = useState<Id>('')
  const [openSideModal, setOpenSideModal] = useState<boolean>(false)
  const [openSideModalOffer, setOpenSideModalOffer] = useState<boolean>(false)
  const [isNew, setIsNew] = useState<boolean>(true)
  const { t } = useT()

  useEffect(() => {
    dispatch(getBedrooms({ partner_id, partner_hotel_id: hotel_id }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner_hotel_rooms.sendBedroomsLoading])

  useEffect(() => {
    if (roomId) {
      dispatch(
        getBedroomsOffer({
          agency_partner_id,
          partner_hotel_room_id: roomId
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    roomId,
    agency_partner_hotel_agreements.sendAgreementOfferLoading,
    agency_partner_hotel_offers.sendBedroomsOfferLoading
  ])

  return (
    <>
      <PageHeader
        extra={[
          <Button
            key="common.actions.add"
            onClick={() => {
              setOpenSideModal(true)
              setIsNew(true)
            }}
            size="default"
            title="common.actions.add"
            type="primary"
          />
        ]}
        onBack={() => history.push('/agencies/partners')}
        title="web.table.bedrooms.bedrooms"
      />
      {partner_hotel_rooms.error && (
        <Alert message={partner_hotel_rooms.error} showIcon type="error" />
      )}
      <Table
        agency_partner_id={agency_partner_id}
        currentPage={currentPage}
        dataSource={partner_hotel_rooms.list.map(partnerHotelRoom => ({
          ...partnerHotelRoom,
          id: partnerHotelRoom.partner_hotel_room_id,
          key: partnerHotelRoom.partner_hotel_room_id
        }))}
        hotel_id={hotel_id}
        isNew={isNew}
        loading={partner_hotel_rooms.loading}
        onChange={page => {
          setCurrentPage(page)
        }}
        openSideModal={openSideModal}
        partner_id={partner_id}
        setIsNew={setIsNew}
        setOpenSideModal={setOpenSideModal}
        setOpenSideModalOffer={setOpenSideModalOffer}
        setRoomId={setRoomId}
        totalPages={partner_hotel_rooms.total_results}
      />
      <Drawer
        footer={
          <CSS.Div>
            <div></div>
            <div>
              <Button
                onClick={async () => {
                  setOpenSideModalOffer(false)
                }}
                type="default"
                title="common.actions.cancel"
              />
            </div>
          </CSS.Div>
          // end footer **************************
        }
        onClose={() => {
          setOpenSideModalOffer(false)
          // formikProps.resetForm(initialValues)
        }}
        title={`${t('web.table.bedrooms.offer.name')} / ${t(
          'web.table.bedrooms.agreement.name'
        )}`}
        visible={openSideModalOffer}
        width="45%"
      >
        <SideModalOffer
          agency_partner_id={agency_partner_id}
          dataSource={agency_partner_hotel_offers.list.map(
            agencyPartnerHotelOffer => ({
              ...agencyPartnerHotelOffer,
              id: agencyPartnerHotelOffer.agency_partner_hotel_offer_id,
              //@ts-ignore
              pension: agencyPartnerHotelOffer.pension,
              key: agencyPartnerHotelOffer.agency_partner_hotel_offer_id
            })
          )}
          roomId={roomId}
        />
      </Drawer>
    </>
  )
}
